import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ExpenseStatsCardProps {
  title: string;
  value: string;
  subtitle?: string;
  className?: string;
}

export const ExpenseStatsCard = ({ title, value, subtitle, className }: ExpenseStatsCardProps) => {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="text-white">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-2xl font-bold text-white">{value}</p>
        {subtitle && <p className="text-sm text-white/80 mt-2">{subtitle}</p>}
      </CardContent>
    </Card>
  );
};